"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.scanAccounts = void 0;
var rxjs_1 = require("rxjs");
var logs_1 = require("@ledgerhq/logs");
var errors_1 = require("@ledgerhq/errors");
var semver_1 = __importDefault(require("semver"));
var derivation_1 = require("../derivation");
var account_1 = require("../account");
var deviceAccess_1 = require("../hw/deviceAccess");
var getAddress_1 = __importDefault(require("../hw/getAddress"));
var getAppAndVersion_1 = __importDefault(require("../hw/getAppAndVersion"));
var access_1 = require("./access");
var syncAccount_1 = require("./syncAccount");
var getOrCreateWallet_1 = require("./getOrCreateWallet");
var createAccountFromDevice_1 = require("./createAccountFromDevice");
var errors_2 = require("./errors");
var errors_3 = require("../errors");
var nativeSegwitAppsVersionsMap_1 = __importDefault(require("./nativeSegwitAppsVersionsMap"));
function scanNextAccount(props) {
    return __awaiter(this, void 0, void 0, function () {
        var logId, core, wallet, currency, accountIndex, onAccountScanned, seedIdentifier, derivationMode, showNewAccount, isUnsubscribed, syncConfig, derivationsCache, getAddr, coreAccount, err_1, account, shouldSkip, emptyCount, shouldIter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    logId = (0, syncAccount_1.newSyncLogId)();
                    core = props.core, wallet = props.wallet, currency = props.currency, accountIndex = props.accountIndex, onAccountScanned = props.onAccountScanned, seedIdentifier = props.seedIdentifier, derivationMode = props.derivationMode, showNewAccount = props.showNewAccount, isUnsubscribed = props.isUnsubscribed, syncConfig = props.syncConfig, derivationsCache = props.derivationsCache, getAddr = props.getAddr;
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") scanNextAccount started. ").concat(currency.id, "|").concat(derivationMode, "|").concat(accountIndex));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, wallet.getAccount(accountIndex)];
                case 2:
                    coreAccount = _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    if (!(0, errors_2.isNonExistingAccountError)(err_1)) {
                        throw err_1;
                    }
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, createAccountFromDevice_1.createAccountFromDevice)({
                            core: core,
                            wallet: wallet,
                            currency: currency,
                            index: accountIndex,
                            derivationMode: derivationMode,
                            isUnsubscribed: isUnsubscribed,
                            derivationsCache: derivationsCache,
                            getAddress: getAddr
                        })];
                case 4:
                    coreAccount = _a.sent();
                    return [3 /*break*/, 5];
                case 5:
                    if (isUnsubscribed() || !coreAccount)
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, syncAccount_1.syncCoreAccount)({
                            core: core,
                            coreWallet: wallet,
                            coreAccount: coreAccount,
                            currency: currency,
                            accountIndex: accountIndex,
                            derivationMode: derivationMode,
                            seedIdentifier: seedIdentifier,
                            logId: logId,
                            syncConfig: syncConfig
                        })];
                case 6:
                    account = _a.sent();
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    shouldSkip = accountIndex < (0, derivation_1.getDerivationModeStartsAt)(derivationMode) ||
                        (!account.used && !showNewAccount) ||
                        !(0, derivation_1.derivationModeSupportsIndex)(derivationMode, accountIndex);
                    (0, logs_1.log)("libcore", "scanning ".concat(currency.id, " ").concat(derivationMode || "default", "@").concat(accountIndex, ": resulted of ").concat(account && !shouldSkip
                        ? "Account with ".concat(account.operationsCount, " txs (xpub ").concat(String(account.xpub), ", fresh ").concat(account.freshAddressPath, " ").concat(account.freshAddress, ")")
                        : "no account", ". ").concat(!account.used ? "ALL SCANNED" : ""));
                    if (!shouldSkip) {
                        onAccountScanned(account);
                    }
                    emptyCount = props.emptyCount || 0;
                    shouldIter = !account.used
                        ? emptyCount < (0, derivation_1.getMandatoryEmptyAccountSkip)(derivationMode)
                        : (0, derivation_1.isIterableDerivationMode)(derivationMode);
                    if (!shouldIter) return [3 /*break*/, 8];
                    return [4 /*yield*/, scanNextAccount(__assign(__assign({}, props), { accountIndex: accountIndex + 1, emptyCount: !account.used ? emptyCount + 1 : 0 }))];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    });
}
var libcoreBlacklist = ["taproot"];
var scanAccounts = function (_a) {
    var currency = _a.currency, deviceId = _a.deviceId, scheme = _a.scheme, syncConfig = _a.syncConfig, getAddressFn = _a.getAddressFn;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return rxjs_1.Observable.create(function (o) {
            var finished = false;
            var unsubscribe = function () {
                finished = true;
            };
            var isUnsubscribed = function () { return finished; };
            var main = (0, access_1.withLibcoreF)(function (core) { return function () { return __awaiter(void 0, void 0, void 0, function () {
                var derivationModes, i, derivationMode, path, result, version, e_1, getAddr, e_2, seedIdentifier, walletName, wallet, onAccountScanned, e_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 14, , 15]);
                            derivationModes = (0, derivation_1.getDerivationModesForCurrency)(currency);
                            if (scheme !== undefined) {
                                derivationModes = derivationModes.filter(function (mode) { return mode === scheme; });
                            }
                            derivationModes = derivationModes.filter(function (m) { return !libcoreBlacklist.includes(m); });
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < derivationModes.length)) return [3 /*break*/, 13];
                            derivationMode = derivationModes[i];
                            path = (0, derivation_1.getSeedIdentifierDerivation)(currency, derivationMode);
                            result = void 0;
                            if (!(derivationMode === "native_segwit")) return [3 /*break*/, 5];
                            if (!nativeSegwitAppsVersionsMap_1["default"][currency.managerAppName]) return [3 /*break*/, 5];
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, (0, getAppAndVersion_1["default"])(transport)];
                        case 3:
                            version = (_a.sent()).version;
                            if (!semver_1["default"].gte(version, nativeSegwitAppsVersionsMap_1["default"][currency.managerAppName])) {
                                return [3 /*break*/, 12];
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            e_1 = _a.sent();
                            // in case the apdu is not even supported, we assume to not do native_segwit
                            if ((e_1 instanceof errors_1.TransportStatusError &&
                                // @ts-expect-error TransportStatusError to be typed on ledgerjs
                                e_1.statusCode === 0x6d00) ||
                                e_1 instanceof errors_3.GetAppAndVersionUnsupportedFormat) {
                                return [3 /*break*/, 12];
                            }
                            throw e_1;
                        case 5:
                            getAddr = getAddressFn
                                ? getAddressFn(transport)
                                : function (opts) { return (0, getAddress_1["default"])(transport, opts); };
                            _a.label = 6;
                        case 6:
                            _a.trys.push([6, 8, , 9]);
                            return [4 /*yield*/, getAddr({ currency: currency, path: path, derivationMode: derivationMode })];
                        case 7:
                            result = _a.sent();
                            return [3 /*break*/, 9];
                        case 8:
                            e_2 = _a.sent();
                            // feature detection: some old app will specifically returns this code for segwit case and we ignore it
                            // we also feature detect any denying case that could happen
                            if (e_2 instanceof errors_1.TransportStatusError ||
                                e_2 instanceof errors_1.UserRefusedAddress) {
                                (0, logs_1.log)("scanAccounts", "ignore derivationMode=" + derivationMode);
                            }
                            return [3 /*break*/, 9];
                        case 9:
                            if (!result)
                                return [3 /*break*/, 12];
                            seedIdentifier = result.publicKey;
                            if (isUnsubscribed())
                                return [2 /*return*/];
                            walletName = (0, account_1.getWalletName)({
                                seedIdentifier: seedIdentifier,
                                currency: currency,
                                derivationMode: derivationMode
                            });
                            return [4 /*yield*/, (0, getOrCreateWallet_1.getOrCreateWallet)({
                                    core: core,
                                    walletName: walletName,
                                    currency: currency,
                                    derivationMode: derivationMode
                                })];
                        case 10:
                            wallet = _a.sent();
                            if (isUnsubscribed())
                                return [2 /*return*/];
                            onAccountScanned = function (account) {
                                return o.next({
                                    type: "discovered",
                                    account: account
                                });
                            };
                            // recursively scan all accounts on device on the given app
                            // new accounts will be created in sqlite, existing ones will be updated
                            return [4 /*yield*/, scanNextAccount({
                                    core: core,
                                    wallet: wallet,
                                    currency: currency,
                                    accountIndex: 0,
                                    onAccountScanned: onAccountScanned,
                                    seedIdentifier: seedIdentifier,
                                    derivationMode: derivationMode,
                                    showNewAccount: (0, account_1.shouldShowNewAccount)(currency, derivationMode),
                                    isUnsubscribed: isUnsubscribed,
                                    syncConfig: syncConfig,
                                    derivationsCache: new createAccountFromDevice_1.DerivationsCache(),
                                    getAddr: getAddr
                                })];
                        case 11:
                            // recursively scan all accounts on device on the given app
                            // new accounts will be created in sqlite, existing ones will be updated
                            _a.sent();
                            _a.label = 12;
                        case 12:
                            i++;
                            return [3 /*break*/, 1];
                        case 13:
                            o.complete();
                            return [3 /*break*/, 15];
                        case 14:
                            e_3 = _a.sent();
                            o.error((0, errors_2.remapLibcoreErrors)(e_3));
                            return [3 /*break*/, 15];
                        case 15: return [2 /*return*/];
                    }
                });
            }); }; });
            main();
            return unsubscribe;
        });
    });
};
exports.scanAccounts = scanAccounts;
//# sourceMappingURL=scanAccounts.js.map